module.exports = __webpack_public_path__ + "img/gox2.7343af82.png";